// extracted by mini-css-extract-plugin
export default {"googleBtn":"login_googleBtn__ddg9f","shadowBtn":"login_shadowBtn__J+oKF","alignText":"login_alignText__UlAym"};